var _rect, _rect2, _rect3, _rect4, _path, _circle, _path2, _path3, _rect5, _rect6, _line, _line2, _line3, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 514,
    height: 173,
    viewBox: "0 0 514 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 513.941,
    height: 172.98,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.6587,
    y: 107.214,
    width: 29.5714,
    height: 56.1111,
    rx: 8.5,
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.0079,
    y: 62.5795,
    width: 48.873,
    height: 70.5873,
    rx: 24.4365,
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42.0714,
    y: 81.881,
    width: 24.746,
    height: 51.2857,
    rx: 12.373,
    stroke: "black",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 48.4127V69.2302H26.3889V48.4127C26.3889 32.9181 38.9498 20.3572 54.4445 20.3572C69.9391 20.3572 82.5 32.9181 82.5 48.4127Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.0476,
    cy: 50.2223,
    r: 6.94444,
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8729 53.8413L82.7936 53.8413",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6666 45.3969L70.7301 24.8889",
    stroke: "black",
    strokeWidth: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 67.3507,
    width: 33.2985,
    height: 45.7761,
    rx: 16.6493,
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40.865,
    y: 163.325,
    width: 16.3016,
    height: 33.1905,
    rx: 8.15079,
    transform: "rotate(-90 40.865 163.325)",
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 36.0397,
    y1: 55.3413,
    x2: 36.0397,
    y2: 60.7858,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 40.865,
    y1: 55.3413,
    x2: 40.865,
    y2: 60.7858,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 54.135,
    y1: 13.119,
    x2: 54.135,
    y2: 20.9762,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.4445,
    cy: 11.0159,
    r: 3.01587,
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.917 78.0553V115.945H126V78.0553H135.917Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.946 115.945V78.0553H158.862L177.178 101.221V78.0553H187.044V115.945H177.178L158.862 92.7789V115.945H148.946Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M200.104 115.945V78.0553H210.021L228.336 101.221V78.0553H238.202V115.945L228.336 115.945L210.021 92.7789V115.945H200.104Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M260.359 97C260.359 98.5075 260.646 99.8978 261.219 101.171C261.792 102.444 262.568 103.549 263.546 104.487C264.525 105.425 265.655 106.162 266.936 106.698C268.252 107.201 269.635 107.452 271.085 107.452C272.535 107.452 273.902 107.201 275.183 106.698C276.499 106.162 277.646 105.425 278.624 104.487C279.636 103.549 280.428 102.444 281.002 101.171C281.575 99.8978 281.862 98.5075 281.862 97C281.862 95.4925 281.575 94.1022 281.002 92.8291C280.428 91.5561 279.636 90.4506 278.624 89.5126C277.646 88.5745 276.499 87.8543 275.183 87.3518C273.902 86.8157 272.535 86.5477 271.085 86.5477C269.635 86.5477 268.252 86.8157 266.936 87.3518C265.655 87.8543 264.525 88.5745 263.546 89.5126C262.568 90.4506 261.792 91.5561 261.219 92.8291C260.646 94.1022 260.359 95.4925 260.359 97ZM249.987 97C249.987 94.1859 250.51 91.5729 251.555 89.1608C252.601 86.7152 254.051 84.5879 255.907 82.7789C257.762 80.9698 259.971 79.5628 262.535 78.5578C265.132 77.5193 267.982 77 271.085 77C274.155 77 276.988 77.5193 279.585 78.5578C282.182 79.5628 284.408 80.9698 286.264 82.7789C288.153 84.5879 289.62 86.7152 290.665 89.1608C291.711 91.5729 292.234 94.1859 292.234 97C292.234 99.8141 291.711 102.444 290.665 104.889C289.62 107.302 288.153 109.412 286.264 111.221C284.408 113.03 282.182 114.454 279.585 115.492C276.988 116.497 274.155 117 271.085 117C267.982 117 265.132 116.497 262.535 115.492C259.971 114.454 257.762 113.03 255.907 111.221C254.051 109.412 252.601 107.302 251.555 104.889C250.51 102.444 249.987 99.8141 249.987 97Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M308.558 78.0553L317.767 101.121L327.026 78.0553H337.802L321.713 115.945H313.82L297.782 78.0553H308.558Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M368.565 86.397H356.776V92.7286H367.907V101.07L356.776 101.07V107.603L368.565 107.603V115.945H346.86V78.0553L368.565 78.0553V86.397Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M390.691 94.9899H392.563C394.519 94.9899 396.02 94.5879 397.066 93.7839C398.111 92.9799 398.634 91.8241 398.634 90.3166C398.634 88.809 398.111 87.6533 397.066 86.8492C396.02 86.0452 394.519 85.6432 392.563 85.6432H390.691V94.9899ZM412.497 115.945H400.152L390.691 101.372V115.945H380.774V78.0553H396.206C398.331 78.0553 400.186 78.3735 401.771 79.0101C403.356 79.6131 404.655 80.4506 405.667 81.5226C406.713 82.5946 407.488 83.8342 407.994 85.2412C408.534 86.6482 408.804 88.1558 408.804 89.7638C408.804 92.6449 408.096 94.99 406.679 96.799C405.296 98.5745 403.238 99.7806 400.506 100.417L412.497 115.945Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M442.651 87.7538C441.572 86.8827 440.492 86.2462 439.413 85.8442C438.334 85.4087 437.288 85.191 436.276 85.191C434.994 85.191 433.949 85.4925 433.139 86.0955C432.33 86.6985 431.925 87.4858 431.925 88.4573C431.925 89.1273 432.127 89.6801 432.532 90.1156C432.937 90.5511 433.46 90.9363 434.101 91.2714C434.775 91.5729 435.517 91.8409 436.327 92.0754C437.17 92.3099 437.996 92.5611 438.806 92.8291C442.044 93.9012 444.405 95.3417 445.889 97.1508C447.407 98.9263 448.166 101.255 448.166 104.136C448.166 106.079 447.829 107.838 447.154 109.412C446.513 110.987 445.552 112.343 444.27 113.482C443.022 114.588 441.471 115.442 439.615 116.045C437.794 116.682 435.72 117 433.392 117C428.569 117 424.1 115.576 419.985 112.729L424.235 104.789C425.719 106.095 427.186 107.067 428.636 107.704C430.087 108.34 431.52 108.658 432.937 108.658C434.556 108.658 435.753 108.29 436.529 107.553C437.339 106.816 437.743 105.978 437.743 105.04C437.743 104.471 437.642 103.985 437.44 103.583C437.237 103.147 436.9 102.762 436.428 102.427C435.956 102.059 435.332 101.724 434.556 101.422C433.814 101.121 432.903 100.786 431.824 100.417C430.542 100.015 429.277 99.5796 428.029 99.1106C426.815 98.608 425.719 97.9548 424.741 97.1508C423.796 96.3467 423.02 95.3417 422.413 94.1357C421.84 92.8961 421.553 91.3384 421.553 89.4623C421.553 87.5863 421.857 85.8945 422.464 84.3869C423.105 82.8459 423.982 81.5394 425.095 80.4673C426.241 79.3618 427.624 78.5075 429.243 77.9045C430.896 77.3015 432.735 77 434.758 77C436.647 77 438.62 77.268 440.678 77.804C442.736 78.3065 444.709 79.0603 446.598 80.0653L442.651 87.7538Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M468.125 97C468.125 98.5075 468.412 99.8978 468.985 101.171C469.559 102.444 470.334 103.549 471.313 104.487C472.291 105.425 473.421 106.162 474.702 106.698C476.018 107.201 477.401 107.452 478.851 107.452C480.302 107.452 481.668 107.201 482.949 106.698C484.265 106.162 485.412 105.425 486.39 104.487C487.402 103.549 488.194 102.444 488.768 101.171C489.341 99.8978 489.628 98.5075 489.628 97C489.628 95.4925 489.341 94.1022 488.768 92.8291C488.194 91.5561 487.402 90.4506 486.39 89.5126C485.412 88.5745 484.265 87.8543 482.949 87.3518C481.668 86.8157 480.302 86.5477 478.851 86.5477C477.401 86.5477 476.018 86.8157 474.702 87.3518C473.421 87.8543 472.291 88.5745 471.313 89.5126C470.334 90.4506 469.559 91.5561 468.985 92.8291C468.412 94.1022 468.125 95.4925 468.125 97ZM457.753 97C457.753 94.1859 458.276 91.5729 459.322 89.1608C460.367 86.7152 461.818 84.5879 463.673 82.7789C465.528 80.9698 467.737 79.5628 470.301 78.5578C472.898 77.5193 475.748 77 478.851 77C481.921 77 484.754 77.5193 487.351 78.5578C489.948 79.5628 492.175 80.9698 494.03 82.7789C495.919 84.5879 497.386 86.7152 498.432 89.1608C499.477 91.5729 500 94.1859 500 97C500 99.8141 499.477 102.444 498.432 104.889C497.386 107.302 495.919 109.412 494.03 111.221C492.175 113.03 489.948 114.454 487.351 115.492C484.754 116.497 481.921 117 478.851 117C475.748 117 472.898 116.497 470.301 115.492C467.737 114.454 465.528 113.03 463.673 111.221C461.818 109.412 460.367 107.302 459.322 104.889C458.276 102.444 457.753 99.8141 457.753 97Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.59f4ad98.svg";
export { ForwardRef as ReactComponent };